/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { LeadingZeroeInterface } from "../../interfaces/LeadingZeroes.interface";
import { FormAction } from "../../types/enums";

/**
 * State of the leading-zero slice: the leading-zero currently being viewed or edited,
 * the active selection, and the open/closed flags for this area's modals.
 */
export interface LeadingZeroeState {
  leadingZeroe: LeadingZeroeInterface;
  openDrawer: boolean;
  openForm: boolean;
  refreshTable: boolean;
  formAction: FormAction;
  openModalDelete: boolean;
}

const initialState: LeadingZeroeState = {
  leadingZeroe: {
    id: "",
    name: "",
    fromDeviceSerial: false,
    refreshAll: false,
    reinitializeAllDevices: false,
    rvu: false,
    setOneBit: false,
    setOneByte: false,
  },
  openDrawer: false,
  openForm: false,
  refreshTable: false,
  formAction: FormAction.Create,
  openModalDelete: false,
};

export const leadingZeroeSlice = createSlice({
  name: "leadingZeroe",
  initialState,
  reducers: {
    updateLeadingZeroe: (state, action: PayloadAction<LeadingZeroeInterface>) => {
      state.leadingZeroe = action.payload;
    },
    updateOpenDrawer: (state, action: PayloadAction<boolean>) => {
      state.openDrawer = action.payload;
    },
    updateOpenForm: (state, action: PayloadAction<boolean>) => {
      state.openForm = action.payload;
    },
    updateRefreshTable: (state, action: PayloadAction<boolean>) => {
      state.refreshTable = action.payload;
    },
    updateFormAction: (state, action: PayloadAction<FormAction>) => {
      state.formAction = action.payload;
    },
    updateOpenModalDelete: (state, action: PayloadAction<boolean>) => {
      state.openModalDelete = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateLeadingZeroe,
  updateOpenDrawer,
  updateOpenForm,
  updateRefreshTable,
  updateFormAction,
  updateOpenModalDelete,
} = leadingZeroeSlice.actions;

export default leadingZeroeSlice.reducer;
